import "./MatchKeyEventComponents.css";

import { ISoccerMatchCardEvent } from "../../../../../../../types";

export const CardEvent = ({
  event,
  isHomeTeamEvent,
  isAwayTeamEvent,
}: {
  event: ISoccerMatchCardEvent;
  isHomeTeamEvent: boolean;
  isAwayTeamEvent: boolean;
}) => {
  let cardType = {
    imgUrl: "",
    type: "",
  };
  if (event.type === "RC") {
    cardType = {
      imgUrl: "/images/match-events/red-card.svg",
      type: "red card",
    };
  } else if (event.type === "YC") {
    cardType = {
      imgUrl: "/images/match-events/yellow-card.svg",
      type: "red card",
    };
  } else if (event.type === "Y2C") {
    cardType = {
      imgUrl: "/images/match-events/second-yellow-card.svg",
      type: "red card",
    };
  }

  return (
    <div className="match-key-event">
      <span className="home-team-match-key-event">
        {isHomeTeamEvent && (
          <>
            <span className="event-player-name">{event.playerName}</span>
            <img
              src={cardType.imgUrl}
              height={16}
              width={10}
              alt={cardType.type}
              className="card-event"
            />
          </>
        )}
      </span>
      <span className="time-match-key-event">{`${event?.timeMin}'`}</span>
      <span className="away-team-match-key-event">
        {isAwayTeamEvent && (
          <>
            <img
              src={cardType.imgUrl}
              height={16}
              width={10}
              alt={cardType.type}
              className="card-event"
            />
            <span className="event-player-name">{event.playerName}</span>
          </>
        )}
      </span>
    </div>
  );
};
